"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPanelStyles = void 0;
const Utils_1 = require("../../../utils/Utils");
const theme_1 = require("../../../themes/typings/theme");
const StyleUtils_1 = require("../../../utils/StyleUtils");
exports.getPanelStyles = (0, Utils_1.createStyleSheet)((theme) => ({
    container: Object.assign(Object.assign(Object.assign({}, (0, StyleUtils_1.flexMixin)('column')), theme.shadows.$dropShadow100), { backgroundColor: theme.__base === theme_1.GlobalBaseTheme.DARK ? theme.colors.$primary400 : theme.colors.$neutral100, padding: `${theme.spacing.$s4} ${theme.spacing.$s3}`, height: '100%', maxHeight: '100%', minHeight: '100%', minWidth: '300px', overflowY: 'auto', width: 'fit-content' }),
}), { name: 'Blueprint-Panel' });
